import Analytics from '@web/services/Analytics/Analytics'
import type { CloseMethod, ModalRule } from '@web/platform.v3/modal-builder/types'

// Имена и параметры едины для всех модалок конструктора (контракт MOB-418): кампания — параметром.
// payload кнопок не отправляем — там может быть токен сессии.
function base (rule: ModalRule) {
  return { modal_id: rule.modalId, ab_test_id: rule.abTestId, variation_id: rule.variationId }
}

export function modalBuilderShown ({ rule, showIndex }: { rule: ModalRule; showIndex: number }): void {
  Analytics.send({ action: 'modal_shown', ...base(rule), revision: rule.revision, trigger: rule.trigger, show_index: showIndex } as unknown as EventBase)
}

export function modalBuilderCtaClick ({ rule, buttonId }: { rule: ModalRule; buttonId: number }): void {
  Analytics.send({ action: 'modal_cta_click', ...base(rule), button_id: buttonId } as unknown as EventBase)
}

export function modalBuilderClosed ({ rule, closeMethod }: { rule: ModalRule; closeMethod: CloseMethod }): void {
  Analytics.send({ action: 'modal_closed', ...base(rule), close_method: closeMethod } as unknown as EventBase)
}
